import { ppData } from '../configs/ppData.config';
import { useSearchParams } from 'react-router-dom';
import { SEARCH_PARAM_KEY_LAYOUT } from '../constants/searchParamKeys';
export const useSEOKeywords = (searchParams = useSearchParams()[0]) => {
    const layout = searchParams.get(SEARCH_PARAM_KEY_LAYOUT) ?? '';
    switch (ppData.mediumHandle) {
        case 'painting-wall-art': {
            switch (layout) {
                case 'framed-canvas':
                    return ['Framed Canvas', 'Print'];
                case 'framed-print':
                    return ['Framed Print', 'Art'];
                case 'poster-print':
                    return ['Poster Print', 'Art'];
                case '1-piece':
                    return ['Canvas', 'Print'];
                default:
                    return [`${layout.substring(0, 1)} Piece Canvas`, 'Wall Art'];
            }
        }
        case 'photography-medium-wall-art': {
            switch (layout) {
                case 'framed-canvas':
                    return ['Framed Canvas', 'Wall Art'];
                case 'framed-print':
                    return ['Framed Print', 'Art'];
                case 'poster-print':
                    return ['Poster Print', 'Art'];
                case '1-piece':
                    return ['Canvas', 'Wall Art'];
                default:
                    return [`${layout.substring(0, 1)} Piece`, 'Print'];
            }
        }
        case 'drawing-wall-art': {
            switch (layout) {
                case 'framed-canvas':
                    return ['Framed Drawing', 'Canvas'];
                case 'framed-print':
                    return ['Framed Art', 'Print'];
                case 'poster-print':
                    return ['Poster Art', 'Print'];
                case '1-piece':
                    return ['Sketch', 'Drawing'];
                default:
                    return [`${layout.substring(0, 1)} Piece Drawing`, 'Art'];
            }
        }
        case 'graffiti-wall-art': {
            switch (layout) {
                case 'framed-canvas':
                    return ['Framed Canvas', 'Graffiti'];
                case 'framed-print':
                    return ['Framed Print', 'Art'];
                case 'poster-print':
                    return ['Poster Print', 'Art'];
                case '1-piece':
                    return ['Canvas', 'Picture'];
                default:
                    return [`${layout.substring(0, 1)} Piece Print`, 'Graffiti'];
            }
        }
        case 'digital-art-wall-art': {
            switch (layout) {
                case 'framed-canvas':
                    return ['Framed Digital Art', 'Canvas'];
                case 'framed-print':
                    return ['Framed Digital Print', 'Art'];
                case 'poster-print':
                    return ['Poster Digital Print', 'Art'];
                case '1-piece':
                    return ['Illustration', 'Print'];
                default:
                    return [`${layout.substring(0, 1)} Piece Digital Art`, 'Print'];
            }
        }
        case 'watercolor-wall-art': {
            switch (layout) {
                case 'framed-canvas':
                    return ['Framed Watercolor', 'Canvas'];
                case 'framed-print':
                    return ['Framed Watercolor Canvas', 'Art'];
                case 'poster-print':
                    return ['Poster Watercolor Canvas', 'Art'];
                case '1-piece':
                    return ['Watercolor Art', 'Print'];
                default:
                    return [`${layout.substring(0, 1)} Piece Artwork`, 'Watercolor'];
            }
        }
        default: {
            return ['Canvas', 'Print'];
        }
    }
};
